import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import CvsApiLogList from "./partials/CvsApiLogList";
import { Route, Routes } from "react-router-dom";
import { Toast } from "primereact/toast";
import moment from "moment-timezone";
import qs from "qs";
import { getFromStorage, setToStorage } from "../../../utils/Helper";
import { isEmpty } from "lodash";
import UrlHelper from "js-url-helper";

const url = new UrlHelper();

const CvsApiLog = (props: any) => {
    const { t } = props;
    const toast = useRef(null);
    const [moduleState, setModuleState] = useState<any>({
        page: 1,
        per_page: 20,
        search: null,
        initialized: false,
        sort_field: null,
        sort_order: null,
        // filters: {
        //     fromDate: moment().startOf("week").format("YYYY-MM-DD[T]HH:mm:ss"),
        //     toDate: moment().endOf("week").format("YYYY-MM-DD[T]HH:mm:ss"),
        // }
    });

    useEffect(() => {
        document.title = t("cvs api logs");

        const prevUrl = qs.parse(url.getSearchParam().prev_url ?? "");
        const fromStorage: any = getFromStorage('supplierCviApisLogsModuleState');
        const defaultState = {
            page: !isEmpty(prevUrl.page) ? url.getSearchParam().page : 1,
            per_page: !isEmpty(prevUrl.per_page) ? url.getSearchParam().per_page : 20,
            search: !isEmpty(prevUrl.search) ? url.getSearchParam().search : null,
            initialized: true,
            sort_field: null,
            sort_order: null,
            filters: {
                fromDate: moment().startOf("week").format("YYYY-MM-DD[T]HH:mm:ss"),
                toDate: moment().endOf("week").format("YYYY-MM-DD[T]HH:mm:ss"),
            },
            ...(!isEmpty(fromStorage) ? JSON.parse(fromStorage) : {})
        }

        setModuleState(defaultState);
        setToStorage('supplierCviApisLogsModuleState', JSON.stringify(defaultState));
    }, []);

    const toastify = (message: any, color: string = 'info', summary: any = null) => {
        if ( toast && toast.current ) {
            // @ts-ignore
            toast.current.show({ severity: color, summary: summary, detail: message });
        }
    };

    const setQuery = (value: any) => {
        setToStorage('supplierPantheonTransferLogsModuleState', JSON.stringify(value));
        setModuleState(value);
    }

    return (
        <div className={ "module-container" }>
            <Toast ref={ toast } />
            <div className="layout-content">
                { ( moduleState && moduleState.initialized ) ?
                    <React.Fragment>
                        <Routes>
                            <Route path={ "/" } element={
                                <CvsApiLogList
                                    moduleState={ moduleState }
                                    toastify={ toastify }
                                    setQuery={ setQuery }
                                /> } />
                        </Routes>
                    </React.Fragment>
                    : <h6>{ t('loading') }</h6> }
            </div>
        </div>
    );
};

// CvsApiLog.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(CvsApiLog);
